import { render, staticRenderFns } from "./OMNotification.vue?vue&type=template&id=f59ac952&scoped=true"
import script from "./OMNotification.vue?vue&type=script&lang=js"
export * from "./OMNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59ac952",
  null
  
)

export default component.exports